import React from 'react'
import {
  Grid,  Typography, IconButton } from '@mui/material'
import Add from '@mui/icons-material/Add'
import { map } from '@/utils/lodash'

const MezzanineLoanForm = ({
  analysisInput,
  mezzanineLoanFields,
  renderInputFields,
  createNewMezzanine }) => (
  <>
    {map(analysisInput.b2rMezzanineOfferPrice, (value, index) => (
      <React.Fragment key={index}>
        <Grid
          container
          direction="row"
          spacing={1}
          sx={{
            alignItems: "center"
          }}
        >
          <Grid>
            <Typography variant="h6">
              Mezzanine Loan {index + 1}
            </Typography>
          </Grid>
          {index + 1 ===
            analysisInput.b2rMezzanineOfferPrice.length && (
            <Grid>
              <IconButton size="small" onClick={createNewMezzanine}>
                <Add />
              </IconButton>
            </Grid>
          )}
        </Grid>
        <Grid container direction="row" spacing={1}>
          {map(mezzanineLoanFields(index), (field) =>
            renderInputFields(false)(field),
          )}
        </Grid>
      </React.Fragment>
    ))}
  </>
)

export default MezzanineLoanForm
